var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0362 13.0019C25.0362 8.96443 24.5904 6.89186 24.5904 6.89186C24.3917 5.08114 22.971 3.64557 21.1603 3.44129C18.5306 3.14229 15.6464 2.90829 13 2.90829C10.3517 2.90829 7.46944 3.14414 4.83787 3.44129C3.95952 3.54165 3.1415 3.93801 2.5184 4.56516C1.89531 5.19231 1.50425 6.01288 1.40958 6.89186C1.40958 6.89186 0.963867 8.96443 0.963867 13C0.963867 17.0374 1.41144 19.11 1.41144 19.11C1.50603 19.9887 1.89682 20.8091 2.51954 21.4362C3.14227 22.0633 3.95986 22.4598 4.83787 22.5606C7.46758 22.8577 10.3554 23.0917 13.0019 23.0917",
    stroke: "#5C5C5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9433 9.96358C24.3676 9.89858 19.7805 9.40643 12.9982 9.40643C6.23817 9.40643 1.66031 9.84472 1.05859 9.90786",
    stroke: "#5C5C5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.05859 16.094C1.66031 16.1553 6.24002 16.5954 12.9982 16.5917C14.5684 16.5917 16.021 16.5653 17.3333 16.524",
    stroke: "#5C5C5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97558 3.07543C8.97558 3.07543 8.52429 8.04886 8.52429 13C8.52429 17.9511 8.97743 22.9246 8.97743 22.9246",
    stroke: "#5C5C5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0244 3.07543C17.0244 3.07543 17.4757 8.04886 17.4757 13C17.4757 14.2112 17.3742 15.1093 17.3332 16.25",
    stroke: "#5C5C5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5209 8.33334C21.7991 8.33334 22.52 7.61242 22.52 6.33248C22.52 5.05426 21.8008 4.33334 20.5209 4.33334C19.2392 4.33334 18.52 5.05255 18.52 6.33248C18.52 7.61242 19.2392 8.33334 20.5209 8.33334Z",
    fill: "#5C5C5C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50085 11.5833C9.77908 11.5833 10.5 10.8624 10.5 9.58248C10.5 8.30426 9.78078 7.58334 8.50085 7.58334C7.21922 7.58334 6.5 8.30255 6.5 9.58248C6.5 10.8624 7.21922 11.5833 8.50085 11.5833Z",
    fill: "#5C5C5C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25085 21.3333C6.52908 21.3333 7.25 20.6124 7.25 19.3325C7.25 18.0543 6.53078 17.3333 5.25085 17.3333C3.96922 17.3333 3.25 18.0526 3.25 19.3325C3.25 20.6124 3.96922 21.3333 5.25085 21.3333Z",
    fill: "#5C5C5C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8929 15.1667V24.4524M15.25 19.8095H24.5357",
    stroke: "#5C5C5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChord);
export default __webpack_public_path__ + "static/media/chord.c90d46ec5493b3e9ba8f8eca50b8e787.svg";
export { ForwardRef as ReactComponent };